import { Box, Typography, useMediaQuery } from "@mui/material";
import { PieChart, Pie, ResponsiveContainer } from "recharts";
import { pricePlanChartData, shufflePlanChartData } from "../tokens/dummy";

// 커스텀 라벨 컴포넌트
const renderCustomLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  name,
  value,
  isMobile,
  unit,
}: any) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + (isMobile ? 40 : 40); // 원 밖으로 조금 더 띄우기
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  let textAnchor;
  if (midAngle > 90 && midAngle < 270) {
    textAnchor = "end";
  } else if (midAngle === 90 || midAngle === 270) {
    textAnchor = "middle";
  } else {
    textAnchor = "start";
  }

  return (
    <>
      <text
        x={
          x +
          (textAnchor === "start"
            ? -10 + (isMobile ? 0 : 10)
            : 15 + (isMobile ? 0 : -10))
        }
        y={y - 5}
        fill="black"
        textAnchor={textAnchor}
        fontWeight={600}
        fontSize={isMobile ? 10 : 13}
        height={isMobile ? 14 : 18}
        letterSpacing={"-0.02em"}
      >
        {name}
      </text>
      <text
        x={
          x +
          (textAnchor === "start"
            ? -10 + (isMobile ? 0 : 10)
            : 15 + (isMobile ? 0 : -10))
        }
        y={y + 10}
        fill="black"
        textAnchor={textAnchor}
        dominantBaseline="central"
        fontSize={isMobile ? 10 : 13}
        height={isMobile ? 14 : 18}
        letterSpacing={"-0.02em"}
      >
        {`${value.toLocaleString()} ${unit}`}
      </text>
    </>
  );
};

const CustomPieChart = ({ type }: { type: "shuffle" | "trice" }) => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const columns = isMobile ? 2 : 1;
  const unit = type === "shuffle" ? "SFL" : "TRI";
  const chartData =
    type === "shuffle" ? shufflePlanChartData : pricePlanChartData;

  const totalValue = chartData.reduce((acc, item) => acc + item.value, 0);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "auto", md: "flex-end" },
      }}
    >
      <Box width={"100%"} height={isMobile ? 320 : 350}>
        <ResponsiveContainer width={"100%"} height={"100%"}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              cx="50%"
              cy="50%"
              innerRadius={isMobile ? "25%" : "45%"}
              outerRadius={isMobile ? "40%" : "60%"}
              startAngle={72}
              endAngle={470}
              label={(props) => renderCustomLabel({ ...props, isMobile, unit })}
              stroke="none"
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>

      <Box
        sx={{
          minWidth: "120px",
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`, // 반응형 컬럼 개수
          justifyContent: "center",
          pb: { md: "40px" },
        }}
      >
        {chartData.map((data) => {
          const percentage = (data.value / totalValue) * 100;
          const formattedPercentage =
            percentage % 1 === 0
              ? percentage.toFixed(0)
              : percentage.toFixed(1);

          return (
            <Box
              key={data.name}
              sx={{ display: "flex", alignItems: "center", gap: "7px" }}
            >
              <Box
                sx={{
                  background: data.fill,
                  width: "8px",
                  height: "8px",
                  borderRadius: "100%",
                }}
              />
              <Typography
                sx={{
                  fontSize: "10px",
                  lineHeight: "18px",
                  letterSpacing: "-0.02em",
                }}
              >
                {data.name}
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "10px",
                  lineHeight: "18px",
                  letterSpacing: "-0.02em",
                }}
              >
                {formattedPercentage}%
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CustomPieChart;
